export default {
  'aiAgentSchedule.form.aiAgent': 'AI agent',
  'aiAgentSchedule.form.instructions': 'Instructions',
  'aiAgentSchedule.form.instructions.edit': 'Edit instructions',
  'aiAgentSchedule.form.instructions.placeholder': 'Describe what the agent should do on each run…',
  'aiAgentSchedule.form.repeat': 'Repeat',
  'aiAgentSchedule.form.repeat.hourly': 'Every hour',
  'aiAgentSchedule.form.repeat.daily': 'Every day',
  'aiAgentSchedule.form.repeat.weekly': 'Every week',
  'aiAgentSchedule.form.repeat.monthly': 'Every month',
  'aiAgentSchedule.form.repeat.businessDay': 'Every business day',
  'aiAgentSchedule.form.repeat.custom': 'Custom…',
  'aiAgentSchedule.form.repeat.manual': 'Manual only',
  'aiAgentSchedule.form.repeat.instant': 'Manual only',
  'aiAgentSchedule.form.repeat.automated': 'Manual only',
  'aiAgentSchedule.form.repeat.none': 'Manual only',
  'aiAgentSchedule.form.repeat.nonscheduled.hint':
    'Manual-only mode: no automatic runs. Use Run whenever you want to start the job.',
  'aiAgentSchedule.form.repeat.none.hint':
    'Manual-only mode: no automatic runs. Use Run whenever you want to start the job.',
  'aiAgentSchedule.form.every': 'Every',
  'aiAgentSchedule.form.unit': 'Unit',
  'aiAgentSchedule.form.starts': 'Starts',
  'aiAgentSchedule.form.starts.now': 'Right now',
  'aiAgentSchedule.form.starts.tomorrow': 'Tomorrow',
  'aiAgentSchedule.form.starts.custom': 'Pick a day…',
  'aiAgentSchedule.form.starts.hint':
    'When the first automatic run is materialized. After that it repeats on the cadence above.',
  'aiAgentSchedule.form.atTime': 'At',
  'aiAgentSchedule.form.onDay': 'On',
  'aiAgentSchedule.form.firstRun': 'First run',
  'aiAgentSchedule.form.section.context': 'Context',
  'aiAgentSchedule.form.context': 'Additional context',
  'aiAgentSchedule.form.context.hint':
    'Optional. Link a task, documents and resources (skill, knowledge, agent or connection) to give the agent more context on each run.',
  'aiAgentSchedule.form.userTask': 'Linked task',
  'aiAgentSchedule.form.documents': 'Documents',
  'aiAgentSchedule.form.runtimeRef.skill': 'Skill',
  'aiAgentSchedule.form.runtimeRef.vector': 'Knowledge',
  'aiAgentSchedule.form.runtimeRef.agent': 'Agent',
  'aiAgentSchedule.form.runtimeRef.connection': 'Connection',
  'aiAgentSchedule.form.documents.add': 'Add documents',
  'aiAgentSchedule.form.documents.empty': 'Click or drag one or more files',
  'aiAgentSchedule.form.section.schedule': 'Schedule',
  'aiAgentSchedule.form.section.sharing': 'Access & collaboration',
  'aiAgentSchedule.form.section.execution': 'Execution',
  'aiAgentSchedule.accessControl.title': 'Who can view and run',
  'aiAgentSchedule.accessControl.help':
    'They can view the job and its history and run it manually, but cannot edit it. They are not added to execution chats.',
  'aiAgentSchedule.accessControl.open': 'Configure access',
  'aiAgentSchedule.accessControl.summary.empty': 'Owner and collaborators only',
  'aiAgentSchedule.accessControl.summary.count':
    '{count, plural, one {# audience configured} other {# audiences configured}}',
  'aiAgentSchedule.collaborators.title': 'Who can collaborate',
  'aiAgentSchedule.collaborators.help':
    'They can view, run and modify the job and see its full history. They also join the chat of new executions. Future changes do not affect past executions.',
  'aiAgentSchedule.collaborators.open': 'Configure collaborators',
  'aiAgentSchedule.collaborators.summary.empty': 'No collaborators',
  'aiAgentSchedule.collaborators.summary.count':
    '{count, plural, one {# collaborator} other {# collaborators}}',
  'aiAgentSchedule.sharing.createHint':
    'Save the job first to configure access and collaborators, or set them now and they will be sent on create.',
  'aiAgentSchedule.sharing.draft.access': 'Access (draft)',
  'aiAgentSchedule.sharing.draft.collaborators': 'Collaborators (draft)',
  'aiAgentSchedule.form.hero.kicker.add': 'New job',
  'aiAgentSchedule.form.hero.kicker.edit': 'Edit job',
  'aiAgentSchedule.form.hero.summary': 'Tell your agent what to do and when to repeat it.',
  'aiAgentSchedule.form.name.placeholder': 'What should this job be called?',
  'aiAgentSchedule.form.cta.add': 'Create job',
  'aiAgentSchedule.form.cta.edit': 'Save changes',
  'aiAgentSchedule.form.nextRun': 'Next run',
  'aiAgentSchedule.form.nextRun.manual': 'Only when run manually',
  'aiAgentSchedule.form.nextExecutionDate': 'Next execution',
  'aiAgentSchedule.form.lastExecutionDate': 'Last execution',
  'aiAgentSchedule.form.maxConcurrentExecutions': 'Max concurrent executions',
  'aiAgentSchedule.form.isActive': 'Schedule active',
  'aiAgentSchedule.form.isActive.hint':
    'Turn on to schedule automatic runs. When off, the job only runs manually.',
  'aiAgentSchedule.form.history': 'History',
  'aiAgentSchedule.tasks.title': 'Execution history',
  'aiAgentSchedule.tasks.description':
    'Runs materialized from this job. You can run, pause or cancel depending on status.',
  'aiAgentSchedule.tasks.triggerType': 'Trigger',
  'aiAgentSchedule.tasks.action.run': 'Run',
  'aiAgentSchedule.tasks.action.pause': 'Pause',
  'aiAgentSchedule.tasks.pause.confirmTitle': 'Pause this execution?',
  'aiAgentSchedule.tasks.pause.confirmContent':
    'Queued runs pause immediately. In-flight runs request a cooperative pause.',
  'aiAgentSchedule.tasks.delete.confirmTitle': 'Cancel / delete this execution?',
  'aiAgentSchedule.tasks.delete.confirmContent':
    'In-flight runs are cancelled cooperatively. History is preserved.',
  'aiAgentSchedule.triggerType.scheduled': 'Scheduled',
  'aiAgentSchedule.triggerType.manual': 'Manual',
  'aiAgentSchedule.triggerType.unknown': 'Unknown',
  'aiAgentSchedule.tasks.requestedOperation': 'Requested operation',
  'aiAgentSchedule.tasks.latestActivity': 'Latest activity',
  'aiAgentSchedule.tasks.latestActivityAt': 'Latest activity at',
  'aiAgentSchedule.tasks.currentToolName': 'Active tool',
  'aiAgentSchedule.tasks.executionMode': 'Execution mode',
  'aiAgentSchedule.tasks.instructions': 'Instructions for this run',
  'aiAgentSchedule.tasks.runtime.title': 'Live activity',
  'aiAgentSchedule.tasks.runtime.tool': 'Using {tool}',
  'aiAgentSchedule.tasks.runtime.working': 'The agent is working…',
  'aiAgentSchedule.tasks.runtime.requestedOperation':
    'A requested operation (pause or cancel) is in progress…',
  'aiAgentSchedule.tasks.meta': 'Execution details',
  'aiAgentSchedule.tasks.output': 'Response',
  'aiAgentSchedule.tasks.output.hint': 'Latest agent output for this execution',
  'aiAgentSchedule.tasks.output.loading': 'Loading response…',
  'aiAgentSchedule.tasks.output.empty': 'No response is available for this thread yet.',
  'aiAgentSchedule.tasks.output.error': 'Could not load the agent response.',
  'aiAgentSchedule.tasks.output.openChat': 'Open in chat',
  'aiAgentSchedule.tasks.documents': 'Documents',
  'aiAgentSchedule.tasks.documents.hint': 'Attachments from this execution thread',
  'aiAgentSchedule.tasks.documents.loading': 'Loading documents…',
  'aiAgentSchedule.tasks.documents.empty': 'No attachments in this thread.',
  'aiAgentSchedule.tasks.documents.error': 'Could not load documents.',
  'aiAgentSchedule.requestedOperation.none': 'None',
  'aiAgentSchedule.requestedOperation.pause': 'Pausing…',
  'aiAgentSchedule.requestedOperation.cancel': 'Cancelling…',
  'aiAgentSchedule.executionMode.manualOnly': 'Manual only',
  'aiAgentSchedule.executionMode.recurring': 'Recurring',
  'aiAgentSchedule.run.confirmTitle': 'Run now',
  'aiAgentSchedule.run.confirmContent':
    'A manual execution of this job will be created with its current instructions.',
  'aiAgentSchedule.run.instructionsPlaceholder':
    'Instructions for this run only. Leave empty to use the job instructions.',
  'aiAgentSchedule.run.instructionsLabel': 'Instructions for this run',
  'aiAgentSchedule.run.optional': 'Optional',
  'aiAgentSchedule.run.overrideNote':
    'Everything you set here applies to this run only; the job keeps its own configuration.',
  'aiAgentSchedule.run.confirmOk': 'Run',
  'aiAgentSchedule.operationType.executescheduledrun': 'Scheduled run',
  'aiAgentSchedule.operationType.unknown': 'Unknown operation',
};
